import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-junta-recursos',
  templateUrl: './junta-recursos.component.html',
  styleUrls: ['./junta-recursos.component.css']
})
export class JuntaRecursosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
